import React from 'react';
import {connect} from "react-redux";
import {Card, Divider, Row, Switch} from "antd";
import {withBreadcrumb, withBreadcrumbCurried} from "../Boilerplate/BreadcrumbContext";
import {compose} from "redux";
import {withLoading} from "../Boilerplate/deferLoaderHoc";
import * as R from 'ramda';
import {getMyProfile, updatePrivacySettings} from "../../actions/users";

const Privacy = ({
                   isContactInfoPrivate,
                   isContactInfoFullyPrivate,
                   setPrivacy,
                 }) => (
  <Card
    className='privacy'
    title={<h1>Privacy</h1>}
  >
    <Divider orientation='left'>Hide My Email / Phone</Divider>
    <Row>
      <Switch
        key="iscontactinfoprivate"
        checked={isContactInfoPrivate}
        onChange={checked => setPrivacy(checked, isContactInfoFullyPrivate)}
      /> From public searches
    </Row>
    <Row>
      <Switch
        key="iscontactinfofullyprivate"
        checked={isContactInfoFullyPrivate}
        onChange={checked => setPrivacy(isContactInfoPrivate, checked)}
      /> From bids that I join
    </Row>
  </Card>
);

export default compose(
  withBreadcrumbCurried({ title: 'Privacy', path: '/settings/privacy' }),
  connect(
    (state, ownProps) => {
      if (R.isEmpty(state.profile)) {
        return {
          loading: true
        };
      }
      return {
        isContactInfoPrivate: state.profile.iscontactinfoprivate,
        isContactInfoFullyPrivate: state.profile.iscontactinfofullyprivate,
      }
    },
    (dispatch, ownProps) => ({
      setPrivacy: (...args) => dispatch(updatePrivacySettings(...args)),
      loader: () => dispatch(getMyProfile())
    })
  ),
  withLoading
)(Privacy);



// WEBPACK FOOTER //
// ./src/components/Settings/Privacy.js